import React from 'react';
import ReactDOM from 'react-dom/client';
import '@csstools/normalize.css';
import 'sanitize.css';
import './App.css';
// import App from './App'; // Old complex system (has black screen bug)
// import App from './NewApp'; // New clean system
// import App from './EmergencyApp'; // EMERGENCY MODE
// import App from './StableApp'; // STABLE VERSION - Prevents black screen on sign-in
import App from './App'; // Back to original app

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

// Performance monitoring
if (typeof reportWebVitals === 'function') {
  try {
    import('./utils/webVitals').then(({ default: reportWebVitals }) => {
      reportWebVitals();
    });
  } catch (error) {
    console.log('Performance monitoring not available');
  }
}